import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  historicalGoldPrice: [],
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };

    case TYPE.GET_HISTORICAL_GOLD_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Data fetch successfully",
        historicalGoldPrice: action.payload.data,
      };
    case TYPE.GET_HISTORICAL_GOLD_PRICE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching",
        historicalGoldPrice: [],
      };

    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default dashboardReducer;
